export const SALUTATIONS = [
  { value: 'mr', label: 'Mr. (श्री)' },
  { value: 'mrs', label: 'Mrs. (श्रीमती)' },
  { value: 'miss', label: 'Miss (सुश्री)' },
];

export const MARITAL_STATUSES = [
  { value: 'married', label: 'Married (विवाहित)' },
  { value: 'unmarried', label: 'Unmarried (अविवाहित)' },
  { value: 'widowed', label: 'Widowed (विधुर/विधवा)' },
  { value: 'divorced', label: 'Divorced (सम्बन्ध विच्छेद)' },
];

export const IDENTITY_DOCUMENTS = [
  { value: 'citizenship', label: 'Citizenship (नागरिकता)' },
  { value: 'voter_id', label: 'Voter ID (मतदाता नामावली)' },
  { value: 'passport', label: 'Passport (पासपोर्ट)' },
  { value: 'other', label: 'Other (अन्य)' },
];

export const FAMILY_RELATIONS = [
  { value: 'grandfather', label: "Grandfather's Name" },
  { value: 'father', label: "Father's Name" },
  { value: 'mother', label: "Mother's Name" },
  { value: 'spouse', label: "Spouse's Name" },
  { value: 'son', label: "Son's Name" },
  { value: 'daughter', label: "Daughter's Name" },
  { value: 'father_in_law', label: "Father-in-law's Name" },
  { value: 'mother_in_law', label: "Mother-in-law's Name" },
];

export const ADDRESS_PARTS = [
  'ProvinceId',
  'DistrictId',
  'LocalLevelId',
  'WardNo',
  'Tole',
  'HouseNo',
];

export const IDENTITY_DOCUMENT_HINTS = {
  citizenship: 'Upload the front and back of the citizenship.',
  voter_id: 'Upload the front and back of the voter ID.',
  passport: 'Upload the passport photo page.',
  other: 'Upload all pages of the document.',
};

export const PAYMENT_MODES = [
  { value: 'cash', label: 'Cash (नगद)' },
  { value: 'cheque', label: 'Cheque (चेक)' },
  { value: 'bank', label: 'Bank (बैंक)' },
  { value: 'online', label: 'Online (अनलाइन)' },
];

export const MAX_DOCUMENT_IMAGES = 10;
